// extracted by mini-css-extract-plugin
module.exports = {"lock":"CombinationLockIcon__lock___2OM8B"};